import React from 'react';
import classes from "./InvalidTraffic.module.css";
import Header from '../components/Header';
import { useTranslation } from 'react-i18next';

const InvalidTraffic = () => {
    const { t } = useTranslation();
    return (
        <>
            <Header />
            <div className={classes.container}>
                <div className={classes.description}>
                    <h2 className={classes.title}>{t("192")}</h2>
                    <ul className={classes.list}>
                        <li className={classes.text}>
                            {t("193")}
                        </li>
                    </ul>

                    <div className={classes.center_button}>
                        <button
                            className={classes.btn_2}
                            type="button"
                            onClick={()=>window.location.href='/'}
                        >
                            {t("194")}
                        </button>
                    </div>
                </div>
            </div>
        </>

    )
}

export default InvalidTraffic